import { useModalState } from 'hooks/modals';
import { PlusIcon_24 } from 'assets/icons';
import Button from 'components/Button';
import EmployersModal from '../EmployersModal';
import messages from './EmployersAddButton.messages';
import styles from './EmployersAddButton.module.css';

const EmployersAddButton = (): JSX.Element => {
  const { isModalVisible, openModal, closeModal } = useModalState();

  return (
    <>
      <Button className={styles.employersButton} onClick={openModal}>
        <PlusIcon_24 className={styles.plusIcon} />
        {messages.newEmployer}
      </Button>
      {isModalVisible && (
        <EmployersModal isOpen={isModalVisible} onRequestClose={closeModal} />
      )}
    </>
  );
};

export default EmployersAddButton;
